import { Button, Grid } from "@material-ui/core"
import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { FormatoFecha } from "./../../../utils/FormatFecha"
import { actulizarFechaSalidaCustomAction, obtenerGrupoClaveViajeAction } from "../../../ducks/cambiosClaveViaje"
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import BackDrop from "../../../global/BackDrop"
import PickerMod from "../../../global/PickersMod";
const FieldFechaCustom = (props) => {
    const { ClaveViaje } = props
    const { clavePaquete } = useSelector(store => store.cambiosGrupales)
    const [editar, setEditar] = useState(false)
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const [fechaPago, setFechaPago] = useState(new Date())
    const handleGuardar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de aplicar este cambio?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                const fecha = FormatoFecha({date: fechaPago, formato: "MMddyyyy"})
                dispatch(actulizarFechaSalidaCustomAction({ ClaveViaje, FechaSalida: fecha})).then(Response => {
                    setLoad(false)
                    if (Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema de conexión con el servidor",
                        });
                        return null
                    }
                    if (Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            text: Response?.Message,
                        });
                        return null
                    }
                    dispatch(obtenerGrupoClaveViajeAction({ ClavePaquete: clavePaquete }))
                    setEditar(false)
                    ToastMessage.fire(
                        'Se aplico el cambio de fecha',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <PickerMod
                            label="Fecha viaje"
                            setSelectedDate={setFechaPago}
                            disableFuture={false}
                            disablePast={true}
                            selectedDate={fechaPago}
                            disabled={!editar}
                        />
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={hangdleClickEditar}
                                disabled={clavePaquete === "0"}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    onClick={handleGuardar}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    onClick={hangdleClickEditar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </div>
    )
}
export default FieldFechaCustom